import { render } from "./App.vue?vue&type=template&id=214df08f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=214df08f&lang=css"
script.render = render

export default script